import { render } from "./NewHomeSectionfile.vue?vue&type=template&id=c46e9c22&scoped=true"
import script from "./NewHomeSectionfile.vue?vue&type=script&lang=js"
export * from "./NewHomeSectionfile.vue?vue&type=script&lang=js"

import "./NewHomeSectionfile.vue?vue&type=style&index=0&id=c46e9c22&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c46e9c22"]])

export default __exports__